<script>
  import BaseHeading from '../BaseHeading/BaseHeading.svelte';
  import PharmacyTile from '../PharmacyTile/PharmacyTile.svelte';

  let {
    headingText,
    headingLevel = 'h2',
    content = '',
    locationsTemplate,
    pharmacies,
    dataTestId = 'featured-pharmacies',
  } = $props();
</script>

<section data-testid={dataTestId} class="bg-gray-mercury w-full px-4 py-6 sm:py-8 lg:pt-14 lg:pb-16">
  <div class="mx-auto">
    <div class="markdown-wrapper mb-4 sm:mx-auto max-w-4xl md:px-4 lg:mb-12 sm:text-center lg:text-lg">
      <BaseHeading {headingLevel} className="text-blue-dark-navy font-medium text-lg md:text-2xl leading-tight mb-4">
        {headingText}
      </BaseHeading>
      {#if content}
        {@html content}
      {/if}
    </div>
    <div
      class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6 lg:gap-8 sm:max-w-lg md:max-w-2xl
        lg:max-w-4xl mx-auto"
    >
      {#each pharmacies.slice(0, 10) as { count, name, image, link, showLogo, isNew }, index}
        <PharmacyTile {name} {image} {link} {showLogo} {isNew} {index} {count} {locationsTemplate} />
      {/each}
    </div>
  </div>
</section>
